/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import { PreventiveSheetService } from './PreventiveSheetService';
import {Configuration} from "../../../Configuration";

class PreventiveSheetServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new PreventiveSheetService($q, resource, $httpParamSerialiserJQLike, $log);
    }

    importConfig(url) {
        return {
            url: url + Configuration.PREVENTIVE_SHEET_IMPORT_PATH,
            method: 'POST',
            headers: {
                'Content-Type': undefined
            },
            transformResponse:
                (data, headers, status) => ((status === 401) || (status === 403)) ? null : data
        };
    }

    generateExportConfig(url) {
        return {
            url: url + Configuration.PREVENTIVE_SHEET_EXPORT_PATH,
            method: 'POST',
            transformResponse:
                (data, headers, status) => {
                    if ((status === 401) || (status === 403)) {
                        return null;
                    } else {
                        let file = {};
                        file.id = data;
                        return file;
                    }
                }
        };
    }

    /** @ngInject */
    getConfig() {
        const config = super.getConfig();
        config.import = this.importConfig(this.resourceUrl);
        config.generateExport = this.generateExportConfig(this.resourceUrl);
        return config;
    }
}

export { PreventiveSheetServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/prevention/service/PreventiveSheetServiceProvider.js